import { IFieldProps } from 'app/components/Forms/FormRender/IFormFieldSetting';
import { FieldHookConfig, useField } from 'formik';
import { Entity } from 'types/common';
import { ArticleWorkOrdersPicker } from '../ArticlePickers';

export const ArticleFormPicker = ({
  label,
  ...props
}: FieldHookConfig<Entity<number> | null> & IFieldProps) => {
  const [field, meta, helpers] = useField<Entity<number> | null>(props);
  return (
    <>
      <ArticleWorkOrdersPicker
        name={props.name}
        queryfilter={props.filter}
        placeholder={props.placeholder}
        label={label}
        onChange={value => {
          helpers.setValue(value, true);
          if (props.onChange) {
            props.onChange(value);
          }
        }}
        onBlur={field?.onBlur}
        value={field.value}
        variant="filled"
        error={meta?.error !== undefined}
        helperText={meta.error}
        fullWidth={props.fullWidth}
        info={props.info}
        disabled={props.disabled}
      />
    </>
  );
};
